<mat-card appearance="outlined">
  <div class="row" ngClass="toggleRow">
    <mat-button-toggle-group
      [ngClass]="setTableInteractions()"
      [value]="selectedVal"
      name="activeInspections"
      aria-label="activeInspections"
    >
      <mat-button-toggle
        (change)="onInspectionListStateChange($event.value)"
        value="active"
        >Active</mat-button-toggle
      >
      <mat-button-toggle
        (change)="onInspectionListStateChange($event.value)"
        value="closed"
        >Closed</mat-button-toggle
      >
    </mat-button-toggle-group>
    @if (!isFilterOpen && showFilters()) {
      <button id="filterButton" (click)="onFilterClick()" mat-button>
        <mat-icon>filter_list</mat-icon>
        FILTERS
      </button>
    }
    @if (isFilterOpen && showFilters()) {
      <button id="closeFilterButton" (click)="onFilterClick()" mat-button>
        <mat-icon>close</mat-icon>
        FILTERS
      </button>
    }
    @if (isFilterOpen) {
      <div class="filterContainer">
        <im-filters
          [disableSearchButton]="isSearchButtonDisabled"
          [hideOriginFilter]="isHideOriginFilter"
          [isStateActive]="isStateActive"
          [activeOrClosedInspections]="selectedVal"
          (searchButton)="getFilteredInspectionList($event)"
          (clearButton)="getInitialInspectionList()"
          (keydown.enter)="onEnterKey()"
        ></im-filters>
      </div>
    }
  </div>
  <div
    class="infiniteScroll"
    (cotecnaInfiniteScroll)="getNextPageByAccount()"
    cotecna-infinite-scroll
    cotecna-automatic-height
  >
    <cotecna-table
      #dynamicTable
      [data]="(dataChanges | async) ?? []"
      [actions]="actions"
      [changeCellTextStyle]="changeCellTextStyle"
      [disableActionIcon]="disableActionIcon"
      [defaultArrowStatus]="defaultArrowStatus"
      [hasActionsTitle]="true"
      [dateFormat]="'dd/MM/yyyy'"
      [dateTimeFormat]="'dd/MM/yyyy HH:mm'"
      [fixedHeader]="true"
      [columns]="displayColumns"
      [hasInfiniteScroll]="true"
      [ngClass]="setTableInteractions()"
      (keydown.enter)="performAction($event)"
      (click)="performAction($event)"
      (sortChange)="onSortChange($event)"
      (clickRow)="onClickRow($event)"
    >
    </cotecna-table>
  </div>
  <mat-card-actions>
    @if (isLoading) {
      <mat-spinner diameter="32"></mat-spinner>
    }
  </mat-card-actions>
</mat-card>

@if (displayNewInspectionButton() && !isAccountTypeManagementOnly) {
  <im-add-inspection-button (reload)="updateInspectionList($event)">
  </im-add-inspection-button>
}
